import actionTypes from '../constants/action-types';
import ClientsApi from '../../../../api/clients-api';
import ClientsHelpers from '../helpers/clients-helpers';
import Helpers from '../../../../common/helpers';
import clientsConstants from '../constants/clients-constants';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';

export const getClients = (dateFrom, dateTo, limit, page, accountType, isExport, isOnlineAffiliate, exportType) => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      const response = await ClientsApi.getClients(dateFrom, dateTo, limit, page, accountType);
      const data = response && response.data;
      dispatch(handleHttpInProgress(false));

      if (isExport) {
        let clients = ClientsHelpers.maskFields(data.results, isOnlineAffiliate);
        clients = ClientsHelpers.formatClientsList(clients);
        Helpers.export(clientsConstants.clients_file_name, clients, exportType, clientsConstants.tableToPrintClass);
      } else {
        dispatch(handleSuccessGetClients(data));
      }
    } catch (error) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const handleSuccessGetClients = data => {
  return {
    type: actionTypes.HANDLE_SUCCESS_GET_CLIENTS,
    data,
  };
};

export const toggleConvertUserModal = show => {
  return {
    type: actionTypes.TOGGLE_CONVERT_USER_MODAL,
    data: {
      show,
    },
  };
};

export const toggleExportTableModal = show => {
  return {
    type: actionTypes.TOGGLE_EXPORT_TABLE_MODAL,
    data: show,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/clients/actions/clients-actions.js